import { useEffect, useState } from "react";
import api from "@/lib/api";
import { formatDateTime } from "./_shared";

export function MembershipPanel() {
  const [apps, setApps] = useState([]);
  useEffect(() => { api.get("/membership").then(({ data }) => setApps(data)); }, []);
  return (
    <div data-testid="membership-panel">
      <p className="eyebrow mb-2">Applications</p>
      <h1 className="font-serif-display text-4xl mb-8" style={{ color: "var(--ser-primary-dark)" }}>
        Membership applications ({apps.length})
      </h1>
      <div className="space-y-4">
        {apps.length === 0 && <p style={{ color: "var(--ser-text-muted)" }}>No applications yet.</p>}
        {apps.map((a) => (
          <div key={a.application_id} className="ser-card p-6" data-testid={`app-${a.application_id}`}>
            <div className="flex items-center gap-2 flex-wrap mb-2">
              <h3 className="font-serif-display text-xl" style={{ color: "var(--ser-primary-dark)" }}>{a.name}</h3>
              <span className="ser-tag ser-tag-accent">{a.tier}</span>
            </div>
            <p className="text-sm mb-3" style={{ color: "var(--ser-text-muted)" }}>{a.email} · {a.cell_number}</p>
            {a.organization && <p className="text-sm mb-2"><strong>Org:</strong> {a.organization}</p>}
            <p className="text-sm leading-relaxed" style={{ color: "var(--ser-text-muted)" }}>{a.motivation}</p>
            <p className="text-xs mt-3" style={{ color: "var(--ser-text-muted)" }}>{formatDateTime(a.created_at)}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

